import { render, staticRenderFns } from "./AvgPriceFarmerList.vue?vue&type=template&id=10a06699"
import script from "./AvgPriceFarmerList.vue?vue&type=script&lang=js"
export * from "./AvgPriceFarmerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports